const updateEquipmentsStr = {
  toastr: 'Equipo actualizado',
  toastrError: 'Equipo ya registrado',
  toastrError2: 'Error al editar Equipo',
  serialNumberError: 'Ya existe un equipo con el mismo número de serie para este sitio',
};

export default updateEquipmentsStr;
